import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import type { InviteChannel, OutreachHistory } from '@/api/types';

/**
 * Full outreach history for one handle: every outreacher who messaged them,
 * when, and who logged the reply.
 *
 * Requires a channel — the same handle on TikTok and Instagram are different
 * creators as far as attribution is concerned, and the backend keys on
 * (channel, lower(handle)).
 */
export function useOutreachHistory(args: {
  channel: InviteChannel | '';
  username: string;
  enabled?: boolean;
}) {
  const api = useApi();
  const username = args.username.trim().replace(/^@/, '');
  const enabled = (args.enabled ?? true) && username.length > 0 && args.channel !== '';

  return useQuery({
    queryKey: ['portal', 'outreach-history', args.channel, username.toLowerCase()],
    queryFn: () =>
      api.get<OutreachHistory>('/portal/outreach-history', {
        channel: args.channel,
        username,
      }),
    enabled,
    staleTime: 10_000,
  });
}
